import { Component, OnInit } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-pet-deceased',
  templateUrl: 'pet-deceased.component.html',
  styleUrls: ['pet-deceased.component.scss'],
})
export class PetDeceasedComponent implements OnInit {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  ngOnInit(): void {}
}
